import React from 'react';
import {RemoteFeed} from "./RemoteFeed";
// export { RemoteFeed as default } from './RemoteFeed';

export default React.memo(RemoteFeed);
